const baseUnit = 4

export default {
  baseUnit: baseUnit,
}
